import React from 'react';

const CircleLeftIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0003 1.6665C5.40866 1.6665 1.66699 5.40817 1.66699 9.99984C1.66699 14.5915 5.40866 18.3332 10.0003 18.3332C14.592 18.3332 18.3337 14.5915 18.3337 9.99984C18.3337 5.40817 14.592 1.6665 10.0003 1.6665ZM11.492 12.4998C11.7337 12.7415 11.7337 13.1415 11.492 13.3832C11.367 13.5082 11.2087 13.5665 11.0503 13.5665C10.892 13.5665 10.7337 13.5082 10.6087 13.3832L7.66699 10.4415C7.42533 10.1998 7.42533 9.79984 7.66699 9.55817L10.6087 6.6165C10.8503 6.37484 11.2503 6.37484 11.492 6.6165C11.7337 6.85817 11.7337 7.25817 11.492 7.49984L8.99199 9.99984L11.492 12.4998Z'
        fill='white'
      />
    </svg>
  );
};

export default CircleLeftIcon;
